(function(angular) {
    angular.module('bizPartEngage').directive('bizProfileMenu', bizProfileMenuDirective);

    bizProfileMenuDirective.$inject = ["bizCore"];

    function bizProfileMenuDirective(bizCoreProvider) {
        var directive = {
            restrict: "E",
            scope: true,
            templateUrl: bizCoreProvider.getView('core.directives.profilemenu', "FrontEnd/Core/Directives/Views/ProfileMenu.html"),
            controller: bizCoreProvider.getController('core.directives.profilemenu', bizProfileMenuController),
            controllerAs: "vm"
        };

        bizProfileMenuController.$inject = ["$rootScope"];

        function bizProfileMenuController($rootScope) {
        	var vm = this;
			vm.IsActive = IsActive;

			function IsActive(m) {
				if (m.State === $rootScope.CurrentState.name || (m.State === ($rootScope.CurrentState.data && $rootScope.CurrentState.data.parentState)))
					return true;

				return false;
			}

        	$rootScope.Initialized.then(function () {
        		vm.States = [{
        			Phrase: "CORE.MYPAGE",
        			State: "base.core.profile.home",
					Icon: "fa-light fa-circle-user"
        		}, {
        			Phrase: "CORE.TIMEREPORT",
        			State: "base.core.profile.timereport",
        			Icon: "fa-light fa-clock",
        			Enabled: $rootScope.HasModuleAccess('TIMEREPORT', $rootScope.AccessTypeRight.Read, true) && $rootScope.GetMiniSetting('ProfileMenu', 'ShowTimeReportTab'),
					PortalSettingForEnable: "IsTimereportEnabled"
                }, {
                    Phrase: "CORE.SUPPORT",
                    Label: "Support",
                    State: "base.core.profile.support",
                    Icon: "fa-light fa-ticket",
                    Enabled: $rootScope.HasModuleAccess('SUPPORT', $rootScope.AccessTypeRight.Read, true) && !portalSettings['UseLegacySupportFrontend'],
                    PortalSettingForEnable: "IsSupportEnabled"
                }, {
        			Phrase: "CORE.GOALBOOK",
        			State: "base.core.profile.goalbook",
					Icon: "fa-light fa-book-open",
        			Enabled: true,
        			PortalSettingForEnable: "IsCheckInEnabled"
        		}, {
        			Phrase: "CORE.LEADERBOARDS",
        			State: "base.core.profile.leaderboards",
        			Icon: "fa-light fa-bar-chart",
        			Enabled: $rootScope.HasModuleAccess('LEVEL_SYSTEM', $rootScope.AccessTypeRight.Read, true),
        			PortalSettingForEnable: "IsLevelSystemEnabled"
                }, {
                    Phrase: "CORE.MYBADGES",
                    State: "base.core.profile.badges",
                    Icon: "fa-light fa-badge-check",
                    Enabled: $rootScope.HasModuleAccess('BADGES', $rootScope.AccessTypeRight.Read, true),
					PortalSettingForEnable: "IsBadgesEnabled"
                }, {
        		    Phrase: "CORE.MYCOLLEAGUES",
        		    State: "base.core.profile.colleagues",
        		    Icon: "fa-light fa-users",
        		    Enabled: $rootScope.HasModuleAccess('UNITS', $rootScope.AccessTypeRight.Read, true) && $rootScope.GetMiniSetting('ProfileMenu', 'ShowMyUnitTab'),
        		    PortalSettingForEnable: "IsUnitEnabled"
        		}, {
                	Phrase: "CORE.WELCOMEPAGE",
        			State: "base.core.welcome",
        			Icon: "fa-light fa-door-open",
					Enabled: $rootScope.GetMiniSetting('ProfileMenu', 'ShowWelcomeTab')
				}, {
					Phrase: "CORE.MYSETTINGS",
					State: $rootScope.desktop ? "base.core.profile.settings" : "base.core.profile.settingsstart",
					Icon: "fa-light fa-gear-complex",
					Enabled: $rootScope.GetMiniSetting('ProfileMenu', 'ShowSettingsTab')
				}];
        	})
        }

        return directive;
    }
})(window.angular);
